import { post } from 'common/apiClient';

export type AdminDetails = {
  partnerId?: string;
  partnerName?: string;
  sourceId?: string;
  loanTypes?: string[];
  userId?: number;
};

export type AdminResponse = {
  data: AdminDetails;
};

export type PasswordResponse = {
  data: UserPayload;
};
export type AddUserResponse = {
  data: UserPayload;
};

export type ChangePasswordPayload = {
  Username: string;
  password: string;
  currentPassword: string;
  confirmPassword: string;
};

export type AddUserPayload = {
  userData: UserPayload;
};

export type UserPayload = {
  userId?: number;
  name?: string;
  username?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  emailID?: string;
  departmentId?: string;
  role?: number;
  isActive?: number;
  isDeleted?: string;
  roleId?: number;
  sourceId?: string;
  createdBy?: string;
  createdOn?: string;
  userName?: string;
  SourceApplicationName?: string;
  IsExtract?: boolean;
  currentPassword?: string;
  confirmPassword?: string;
  message?: string;
};

export type AddUserList = {
  userName: string;
  password: string;
  firstName: string;
  lastName: string;
  emailID: string;
  departmentId: string;
  roleId: string;
  isActive: string;
  isDeleted: string;
  createdBy: string;
  createdOn: string;
  Username: string;
  SourceApplicationName?: string;
};

export type AddAdminPayload = {
  partnerName?: string;
  sourceId?: string;
  loanTypes?: string[] | string;
  userId?: number;
  sourceApplicationName?: string;
};

export const adduserList = (payload?: UserPayload) =>
  post<AddUserResponse>('/usermanagement/addMSTUser', payload);
export const addAdmin = (payload: AddAdminPayload) =>
  post<AdminResponse>('/usermanagement/addPartner', payload);
export const userchangepassword = (payload?: UserPayload) =>
  post<PasswordResponse>('/usermanagement/changePassword', payload);
export const userforgotpassword = (payload?: UserPayload) =>
  post<PasswordResponse>('/usermanagement/forgotPassword', payload);
